export enum StaticFilter {
    Price = 'price',
    Sorting = 'sorting',
}
